(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const cartForm = document.querySelector('[data-cart-form]');

    if (!cartForm) return;

    const quantityInputs = cartForm.querySelectorAll('[data-cart-quantity-input]');
    const removeModal = cartForm.querySelector('[data-cart-remove-modal]');
    const cancelButton = cartForm.querySelector('[data-cart-remove-cancel]');
    const confirmButton = cartForm.querySelector('[data-cart-remove-confirm]');
    const submitDelay = 700;
    let submitTimeoutId;
    let pendingInput;
    let pendingValue;
    let pendingRemovalInput;

    const submitPendingUpdate = () => {
      if (!pendingInput) return;
      if (pendingValue === undefined) return;
      if (pendingInput.dataset.cartQuantityValue === pendingValue) return;
      if (pendingValue === '') return;
      if (pendingRemovalInput === pendingInput) return;

      pendingInput.value = pendingValue;
      pendingInput.dataset.cartQuantityValue = pendingValue;
      pendingInput = null;
      pendingValue = undefined;
      cartForm.requestSubmit();
    };

    const clearPendingSubmit = () => {
      window.clearTimeout(submitTimeoutId);
      pendingInput = null;
      pendingValue = undefined;
    };

    const closeRemoveModal = () => {
      if (!removeModal) return;

      removeModal.classList.add('hidden');
      removeModal.classList.remove('flex');
      removeModal.setAttribute('aria-hidden', 'true');
    };

    const openRemoveModal = (input) => {
      clearPendingSubmit();

      if (!removeModal) {
        scheduleSubmit(input);
        return;
      }

      pendingRemovalInput = input;
      removeModal.classList.remove('hidden');
      removeModal.classList.add('flex');
      removeModal.setAttribute('aria-hidden', 'false');
      confirmButton?.focus();
    };

    const scheduleSubmit = (input) => {
      pendingInput = input;
      pendingValue = input.value;
      window.clearTimeout(submitTimeoutId);
      submitTimeoutId = window.setTimeout(submitPendingUpdate, submitDelay);
    };

    quantityInputs.forEach((input) => {
      input.dataset.cartQuantityValue = input.value;

      input.addEventListener('change', () => {
        if (input.value === '0') {
          openRemoveModal(input);
          return;
        }

        scheduleSubmit(input);
      });
    });

    cancelButton?.addEventListener('click', () => {
      if (pendingRemovalInput) {
        pendingRemovalInput.value = pendingRemovalInput.dataset.cartQuantityValue;
        pendingRemovalInput.focus();
      }

      pendingRemovalInput = null;
      closeRemoveModal();
    });

    confirmButton?.addEventListener('click', () => {
      if (!pendingRemovalInput) {
        closeRemoveModal();
        return;
      }

      scheduleSubmit(pendingRemovalInput);
      pendingRemovalInput = null;
      closeRemoveModal();
    });

    removeModal?.addEventListener('click', (event) => {
      if (event.target !== removeModal) return;

      cancelButton?.click();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!pendingRemovalInput) return;

      cancelButton?.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-gallery"] && !Shopify.designMode) return;
  try {
    
  class ProjectGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.wrap = this.track ? this.track.parentElement : null;
      this.cursorButton = this.querySelector('[data-gallery-cursor-button]');
      this.lightbox = this.querySelector('[data-gallery-lightbox]');
      this.lightboxImage = this.querySelector('[data-gallery-lightbox-image]');
      this.lightboxCaption = this.querySelector('[data-gallery-lightbox-caption]');
      this.lightboxFrame = this.querySelector('[data-gallery-lightbox-frame]');
      this.items = Array.from(this.querySelectorAll('[data-gallery-item]'));
      this.activeIndex = 0;

      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.scrollByAmount(-1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.scrollByAmount(1));

      if (this.wrap) {
        this.wrap.addEventListener('mousemove', (event) => this.handlePointerMove(event));
        this.wrap.addEventListener('mouseleave', () => this.hideCursorButton());
      }

      this.items.forEach((item, index) => {
        item.querySelector('[data-gallery-trigger]')?.addEventListener('click', () => this.openLightbox(index));
      });

      this.querySelector('[data-gallery-close]')?.addEventListener('click', () => this.closeLightbox());
      this.querySelector('[data-gallery-lightbox-prev]')?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.stepLightbox(-1);
      });
      this.querySelector('[data-gallery-lightbox-next]')?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.stepLightbox(1);
      });
      this.lightbox?.addEventListener('click', () => this.closeLightbox());
      this.lightboxFrame?.addEventListener('click', (event) => event.stopPropagation());

      this.handleKeydown = (event) => {
        if (!this.lightbox || this.lightbox.hasAttribute('hidden')) return;
        if (event.key === 'Escape') this.closeLightbox();
        if (event.key === 'ArrowLeft') this.stepLightbox(-1);
        if (event.key === 'ArrowRight') this.stepLightbox(1);
      };
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);
    }

    scrollByAmount(direction) {
      if (!this.track) return;
      this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: 'smooth' });
    }

    handlePointerMove(event) {
      if (!this.cursorButton || !this.wrap) return;
      const rect = this.wrap.getBoundingClientRect();
      this.cursorButton.style.left = event.clientX - rect.left + 'px';
      this.cursorButton.style.top = event.clientY - rect.top + 'px';

      if (event.target.closest('[data-gallery-item]')) {
        this.showCursorButton();
      } else {
        this.hideCursorButton();
      }
    }

    showCursorButton() {
      this.cursorButton?.classList.remove('opacity-0', 'scale-75');
      this.cursorButton?.classList.add('opacity-100', 'scale-100');
    }

    hideCursorButton() {
      this.cursorButton?.classList.remove('opacity-100', 'scale-100');
      this.cursorButton?.classList.add('opacity-0', 'scale-75');
    }

    openLightbox(index) {
      if (!this.lightbox) return;
      this.activeIndex = index;
      this.renderLightbox();
      this.lightbox.removeAttribute('hidden');
      this.lightbox.classList.remove('hidden');
      this.lightbox.classList.add('flex');
      document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.setAttribute('hidden', '');
      this.lightbox.classList.add('hidden');
      this.lightbox.classList.remove('flex');
      document.body.style.overflow = '';
    }

    stepLightbox(direction) {
      const total = this.items.length;
      if (!total) return;
      this.activeIndex = (this.activeIndex + direction + total) % total;
      this.renderLightbox();
    }

    renderLightbox() {
      const item = this.items[this.activeIndex];
      if (!item || !this.lightboxImage) return;
      this.lightboxImage.src = item.dataset.fullSrc || '';
      this.lightboxImage.alt = item.dataset.caption || '';
      if (this.lightboxCaption) this.lightboxCaption.textContent = item.dataset.caption || '';
      if (this.lightboxFrame) this.sizeLightboxFrame(parseFloat(item.dataset.ratio) || 16 / 9);
    }

    sizeLightboxFrame(ratio) {
      const maxWidth = Math.min(window.innerWidth * 0.94, 1200);
      const maxHeight = window.innerHeight * 0.88;
      this.lightboxFrame.style.aspectRatio = String(ratio);
      this.lightboxFrame.style.width = `${Math.min(maxWidth, maxHeight * ratio)}px`;
    }
  }

  customElements.define('project-gallery', ProjectGallery);

  } catch(e) { console.error(e); }
})();
})();
